import { Fragment } from 'react/jsx-runtime';

import { useGetCredits } from '../hooks';

import { CreditsListError } from './CreditsListError';
import { CreditsListLoading } from './CreditsListLoading';
import { CreditsTableRow } from './CreditsTableRow';
import { CreditsListStatus } from './CreditsListStatus';

export const CreditsList = () => {
  const creditsQuery = useGetCredits();

  if (creditsQuery.isLoading) return <CreditsListLoading />;

  if (!creditsQuery.data || !Array.isArray(creditsQuery.data.data))
    return <CreditsListStatus />;

  if (creditsQuery.isError)
    return <CreditsListError refetch={creditsQuery.refetch} />;

  return (
    <Fragment>
      {creditsQuery.data &&
        creditsQuery.data.data.map((credit, index) => {
          return <CreditsTableRow key={index} {...credit} />;
        })}
    </Fragment>
  );
};
